// ═══════════════════════════════════════════════════════════════
// ClearView CRM Pathway Defaults & Color Options
// ═══════════════════════════════════════════════════════════════

// Prospect is position 0 — leftmost column in Cultivate pipeline.
// It sits outside the scoring engine's automatic assignment.
// A prospect stays a prospect until the manager manually converts them.
export const DEFAULT_PATHWAYS = [
  { id: "prospect", name: "Prospect", color: "#b91c1c" },
  { id: "unengaged", name: "New Donor", color: "#9ca3af" },
  { id: "connect", name: "Donor of Record", color: "#3b82f6" },
  { id: "contribute", name: "Engagement", color: "#10b981" },
  { id: "lead", name: "Advocate", color: "#f59e0b" },
];

export const PATHWAY_COLORS = [
  "#f97316",
  "#9ca3af",
  "#3b82f6",
  "#10b981",
  "#f59e0b",
  "#ef4444",
  "#8b5cf6",
  "#ec4899",
  "#14b8a6",
  "#6366f1",
  "#84cc16",
  "#06b6d4",
];
